export default __webpack_public_path__ + "static/media/c001-general2024-8.e94846f3.png";